export function metersToFeet(meters: number): number {
  return meters * 3.28084;
}

export function feetToMiles(feet: number): number {
  return feet / 5280;
}
